import { computed } from 'vue'

import type { AppTextColor } from '@shared/ui/typography'
import type {
  AppDropdownItemColor,
  UseAppDropdownItemOptions,
  UseAppDropdownItemReturn,
} from '../types/interfaces'

const TONE_COLORS: Record<AppDropdownItemColor, AppTextColor | undefined> = {
  default: undefined,
  blue: 'blue-700',
  red: 'red-600',
  emerald: 'emerald-600',
}

export const useAppDropdownItem = (
  options: UseAppDropdownItemOptions,
): UseAppDropdownItemReturn => {
  const { props, onClick } = options

  const itemClasses = computed<(string | Record<string, boolean>)[]>(() => [
    'app-dropdown-item',
    {
      'app-dropdown-item--selected': props.selected === true,
      'app-dropdown-item--disabled': props.disabled === true,
      'app-dropdown-item--with-checkbox': props.checkbox === true,
    },
  ])

  const textColor = computed<AppTextColor>(() => {
    if (props.disabled) return 'slate-300'

    return TONE_COLORS[props.color ?? 'default'] ?? 'slate-900'
  })

  const iconColor = computed<AppTextColor | undefined>(() => {
    if (props.disabled) return 'slate-300'

    return TONE_COLORS[props.color ?? 'default']
  })

  const handleClick = (): void => {
    if (props.disabled === true) return
    onClick()
  }

  return {
    itemClasses,
    textColor,
    iconColor,
    handleClick,
  }
}
